import { render, staticRenderFns } from "./orderImpDetail.vue?vue&type=template&id=3d5256b9&scoped=true&"
import script from "./orderImpDetail.vue?vue&type=script&lang=js&"
export * from "./orderImpDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderImpDetail.vue?vue&type=style&index=0&id=3d5256b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5256b9",
  null
  
)

export default component.exports